import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import FormError from '../FormError';
import { getValidationClass } from '@/utils/formUtils';
import { FIELD_TYPE, VALIDATION } from '@/constants/form';

export const EmailField = ({
  id, name, className, isRequired, ...rest
}) => {
  const { register, formState, formState: { errors } } = useFormContext();

  return (
    <>
      <input
        id={id}
        data-rbf={`input${id ? '-' + id : ''}`}
        type={FIELD_TYPE.TEXT}
        className={[
          'form-control',
          className,
          getValidationClass(name, formState)
        ].filter(Boolean).join(' ')}
        name={name}
        {...register(name, {
          required: isRequired,
          pattern: {
            value: VALIDATION.EMAIL_REGEX,
            message: 'forms.validEmail'
          }
        })}
        {...rest}
      />
      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

EmailField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  isRequired: PropTypes.bool
};

export default EmailField;
